export function initDericSearch() {
    const dericSearch = document.getElementById('ask-deric-form');

    if(dericSearch) {
        dericSearch.addEventListener('submit', function(e){
            e.preventDefault();
            let searchData = new FormData(dericSearch);
            askDeric(searchData);
        })
    }
}

function askDeric(formData) {
    const resultsContainer = document.querySelector('.faqSearchResults')
    // add action and ajax nonce to formData
    formData.set('action', 'ask_deric')
    formData.set('nonce', Ajax.nonce)

    // collect form params
    const params = new URLSearchParams(formData);

    resultsContainer.innerHTML = '<div class="ajaxLoader"><div class="dots"><div></div><div></div><div></div></div></div>';

    fetch(Ajax.ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
        },
        body: params
    }).then((response) => {
        //console.log(response)
       return response.text();

    }).then((html) => {
        resultsContainer.innerHTML = html;
        let search = params.get('search')
        insp_set_search_vars([{"search": search}])

    }).catch((err) => {

        // There was an error
        return err

    });
}

function updateUrlParameter(uri, params) {
    //console.log(uri)
    //console.log(params)
    // remove the hash part before operating on the uri
    let i = uri.indexOf('#');
    let hash = i === -1 ? ''  : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    params.forEach((param) => {

      for (const [key, value] of Object.entries(param)) {
        //console.log(key+': '+value)
        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = uri.indexOf('?') !== -1 ? "&" : "?";
      
        if (!value) {
          // remove key-value pair if value is empty
          uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
          if (uri.slice(-1) === '?') {
            uri = uri.slice(0, -1);
          }
          // replace first occurrence of & by ? if no ? is present
          if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
          
        } else if (uri.match(re)) {
          uri = uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
          uri = uri + separator + key + "=" + value;
        }
      }

    })

    return uri + hash;
    //return queries + hash;
  }

    // update pagination
    function insp_update_pagination(params) {
        const pagination = document.querySelector('.pagination')
        let pages = pagination.querySelectorAll('.page-numbers');
        if(pages) {
            pages.forEach((page) => {

            let href = page.href
            if(href) {
                let url = updateUrlParameter(href, params)
                //console.log(url)
                page.href = url
            }
        })
        }
    }

    // update url history
    function insp_set_search_vars(params) {
        // get location without params
        let url = location.protocol + '//' + location.host + location.pathname

        //console.log(url)
        //console.log(params)
        let currentUrl = updateUrlParameter(url, params)
        //console.log(currentUrl)

        if(url.includes('/page/')) {
            // url.replace(/page\/([0-9]+)/, '');
            let newURL = url.replace(/\/page\/([0-9]+)/, '')
            // replace original object with new replaced string
            window.history.replaceState(url, null, newURL)
            // replace now current url object with changed params
            window.history.replaceState(url, null, currentUrl)
        } else {
            window.history.replaceState(url, null, currentUrl)
        }

        insp_update_pagination(params)

    }   

